import { render, staticRenderFns } from "./ContinuousFilingFormDetailsBox.vue?vue&type=template&id=dcf6e1da&scoped=true&"
import script from "./ContinuousFilingFormDetailsBox.vue?vue&type=script&lang=js&"
export * from "./ContinuousFilingFormDetailsBox.vue?vue&type=script&lang=js&"
import style0 from "./ContinuousFilingFormDetailsBox.vue?vue&type=style&index=0&id=dcf6e1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf6e1da",
  null
  
)

export default component.exports